/**
 *
 * @param {string} theme
 * @param {string} lang
 * @return {Object}
 */

export const MainTheme = {
    dark: {
        mainBg: "#0c142a",
        secondaryBg: "#0e1123",
        primaryBg: "#202d4f",
        color: "#c3c5b7",
        secondary: "#eaecef",
        primary: "white",
        hover: "#26282b70",
        active: "#0d60a1",
        exitRed: "#a12356",
        orange: "#ffc800",
        mainOrange: "#0d60a1",
        mainRed: "#e9106c",
        mainGreen: "#1ce087",
        search: "#161a1e",
        input: "#3f4243",
        textArea: "#44464c",
        dropdown: "#36383C",
        tradeBg: "rgb(21 31 45)",
        tInputBg: "#182333",
        otcInput: "#0e111a",
        mChart: "#131722",
        orderHover: "#5e6673",
        inActive: "#72747830",
        headerBg: "#131b26",
        textColor: "#fafafa",
        main: "#0d60a1",
        kayaHover: "#ffffff10",
        colorHeaderIconHover: "#FFFFFF19",
        headerShadow: "#061222",
        settingBg: 'rgb(43, 49, 57)',
    },
    light: {
        mainBg: "#fafafa",
        secondaryBg: "white",
        primaryBg: "white",
        color: "#191c20",
        secondary: "#595e67",
        primary: "#595e67",
        hover: "#fafafa70",
        active: "#0d60a1",
        exitRed: "#a12356",
        mainOrange: "#0d60a1",
        mainRed: "#f6465d",
        mainGreen: "#37b88b",
        search: "#b7bdc6",
        input: "#fafafa",
        textArea: "#f1f2f3",
        dropdown: "#707a8a",
        tradeBg: "#ffffff",
        tInputBg: "#f0f1f2",
        otcInput: "#f0f1f2",
        mChart: "wheat",
        orderHover: "#f0f1f2",
        inActive: "#72747830",
        headerBg: "#fff",
        headerShadow: "#ccc",
        textColor: "#061222",
        main: "#1099f9",
        kayaHover: "#00000010",
        settingBg: '#fafafa',
        colorHeaderIconHover: "#00000019",
    },
}

const getMainTheme = (theme, lang) => {
    const chosenTheme = { ...MainTheme[theme] }
    chosenTheme.english = lang === "en"
    return chosenTheme
}

export { getMainTheme }
